import { render, staticRenderFns } from "./PreciseTeach.vue?vue&type=template&id=6897531d&scoped=true"
import script from "./PreciseTeach.vue?vue&type=script&lang=js"
export * from "./PreciseTeach.vue?vue&type=script&lang=js"
import style0 from "./PreciseTeach.vue?vue&type=style&index=0&id=6897531d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897531d",
  null
  
)

export default component.exports